/**
 * /devhub/ai — Area B (AI Orchestrator). REQ-001.91 DevHub UI rebuild · Phase 1 IA shell.
 */
import { createFileRoute } from '@tanstack/react-router';

import { DevHubAreaShell } from '../components/devhub/DevHubAreaShell';

export const Route = createFileRoute('/devhub/ai')({ component: DevHubAi });

function DevHubAi() {
  return (
    <DevHubAreaShell
      title="AI Orchestrator"
      subtitle="Local-Granite chat, prompt intake, task queue, traces and the registries hub. AI proposes — the operator approves; paid_model_called=false."
      pages={[
        { label: 'AI Chat (with history)', description: 'Durable chat — live history; new send held at the worker-gated boundary.', status: 'live', to: '/devhub/ai-chat' },
        { label: 'Prompt Intake', description: 'Composer with deterministic risk classification + dispatch.', status: 'live', to: '/devhub/intake' },
        { label: 'Task Queue', description: 'Local-AI orchestrator tasks; row → detail (Send-to-AI analyze).', status: 'live', to: '/devhub/tasks' },
        { label: 'Execution Traces', description: 'Agent / ReWOO trace events from the orchestrator.', status: 'live', to: '/devhub/exec-traces' },
        { label: 'Models', description: 'Local Granite + embedding model registry.', status: 'live', to: '/devhub/models' },
        { label: 'Agents', description: 'Agent registry — roles, planes and grounding policy.', status: 'live', to: '/devhub/agents' },
        { label: 'Context packs', description: 'Reusable context packs for grounded generation.', status: 'live', to: '/devhub/context-packs' },
        { label: 'RAG context', description: 'Local RAG corpus and retrieval profiles.', status: 'live', to: '/devhub/rag' },
        { label: 'Embedding Atlas', description: '2D UMAP projection of every knowledge_chunks row in the local RAG. Click a point for Send-to-AI.', status: 'live', to: '/devhub/embedding-atlas' },
        { label: 'Adobe jobs', description: 'Adobe generation jobs — status and evidence.', status: 'live', to: '/devhub/adobe' },
      ]}
    />
  );
}
